export default __webpack_public_path__ + "static/mountain-range-007cbdd323e5139f3705740629e71437.jpeg";